import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import SingleList from './SingleList';
import { setSingleGroupListInfo } from '@Redux/search/actions';
import { RootState } from '@Redux/search/store';
import { useMediaQuery } from 'react-responsive';
import { Pagination } from '@lion-design/core';
import { I_SingleGroup } from '@Redux/search/interfaces';
import styles from '../styles.module.scss';
import getResultConditions from '@utils/getResultConditions';
import ResultNoData from '@components/SearchPage/ResultNoData';
import Spinner from '@components/Common/Spinner';

interface I_Props {
    setIsContactStaffOpen: Function;
}

const Pc = ({ setIsContactStaffOpen }: I_Props) => {
    const search = useSelector((state: RootState) => state.search);
    const {
        SingleGroupListInfo,
        DepthInfo,
        FilterItems,
        SortListBy,
        TagFiltersShow,
        ChangeItem,
        Tags,
        callJson,
    } = search;

    const curPage = location.pathname;
    const [isNowPage, setIsNowPage] = useState<number>(1);
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });
    const dispatch = useDispatch();
    const { data, isLoading } = SingleGroupListInfo;
    const resultConditions = getResultConditions({
        FilterItems,
        DepthInfo,
        SortListBy,
        TagFiltersShow,
        search,
    });

    // PC 版篩選重新取得結果
    useEffect(() => {
        if (!isMobile) {
            const reqBody = {
                ...resultConditions,
                Page: 1,
                PageSize: 10,
            };
            dispatch(setSingleGroupListInfo(reqBody));
            setIsNowPage(1);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, resultConditions.TripTypes, Tags]);

    useEffect(() => {
        if (ChangeItem) {
            if (!isMobile) {
                const reqBody = {
                    ...resultConditions,
                    Page: 1,
                    PageSize: 10,
                };
                dispatch(setSingleGroupListInfo(reqBody));
                setIsNowPage(1);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [DepthInfo, FilterItems, SortListBy, TagFiltersShow]);

    // 頁數改變時重新打API
    const getCurPageList = (page: number) => {
        const reqBody = {
            ...resultConditions,
            Page: page,
            PageSize: 10,
        };
        dispatch(setSingleGroupListInfo(reqBody));
        setIsNowPage(page);
    };

    if (isLoading) return <Spinner />;
    if (data.SingleGroupList.length > 0)
        return (
            <>
                <div className={styles.fakeHeader}>
                    <div className={styles.proName}>產品名稱</div>
                    <div className={styles.proDate}>日期</div>
                    <div className={styles.proAir}>航空</div>
                    <div className={styles.proStatus}>團況</div>
                    <div className={styles.proPrice}>售價</div>
                </div>
                {data.SingleGroupList.map((item: I_SingleGroup, i: number) => (
                    <SingleList
                        key={i}
                        groupData={item}
                        setIsContactStaffOpen={setIsContactStaffOpen}
                    />
                ))}
                <Pagination
                    className={styles.pageBar}
                    total={data.TotalCount}
                    pageSize={10}
                    current={isNowPage}
                    onChange={(page) => {
                        getCurPageList(page);
                        // 換頁後跳至最放上
                        window.scrollTo(0, 0);
                    }}
                />
            </>
        );

    return <ResultNoData />;
};

export default Pc;
